import Vue from 'vue'

export default Vue.extend({
    props: {
        tooltipText: {type: String, required: true}
    }
})